import { EditOutlined, LockOutlined } from '@ant-design/icons'
import { useClickAway, useToggle } from 'ahooks'
import { InputNumber, Tag } from 'antd'
import cls from 'classnames'
import moment from 'moment'
import React from 'react'

import s from './click-away.module.less'

export const ClickAwayWeekInputNumber: React.FC<{
  showLockedIcon?: boolean
  required: boolean
  disabled?: boolean
  readonly?: boolean
  year: number
  week: number
  isActive?: boolean
  value:
    | {
        selfId?: string | undefined
        userWorkResourceSelfId?: string | undefined
        year: string
        week: string
        workload: number | null
      }
    | undefined
  onChange: (value: number | string | null) => void
  onUpdate: (value: number | string | null) => void
}> = ({ value: v, year, week, readonly, isActive, disabled, required, showLockedIcon, onUpdate, onChange }) => {
  const [isEditing, { toggle }] = useToggle(!!isActive)
  const [value, setValue] = React.useState<string | number | null>(v?.workload || null)
  const ref = React.useRef<HTMLDivElement>(null)

  useClickAway(() => {
    if (!isActive && isEditing) {
      onUpdate(value)
      toggle(false)
    }
  }, ref)

  React.useEffect(() => {
    if (v?.workload !== value) {
      onChange(value)
    }
  }, [value])

  if (disabled) {
    return <div className={s.readonlyText}> 当前周不在排期时间内</div>
  }

  return (
    <div className={cls('flex items-center', readonly ? s.readonlyText : s.subElementCursorPointer)} ref={ref}>
      {isEditing && !readonly ? (
        <InputNumber
          status={required && !value ? 'error' : undefined}
          style={{ width: 150, cursor: 'pointer', marginLeft: 8 }}
          disabled={readonly}
          readOnly={!isEditing}
          min={0}
          precision={1}
          addonBefore={
            <span>
              {year}-{week}
            </span>
          }
          size='small'
          value={v?.workload || undefined}
          onChange={(v) => setValue(v)}
        />
      ) : (
        <div
          className='whitespace-nowrap'
          onClick={(e) => {
            if (!readonly) {
              e.stopPropagation()
              toggle(true)
            }
          }}
        >
          <Tag icon={showLockedIcon ? <LockOutlined /> : null}>
            <span>{moment().year(year).week(week).format('GGGG-Wo')}</span>
          </Tag>
          <span>{v?.workload}</span>
          {!readonly && <EditOutlined className='ml-2' />}
        </div>
      )}
    </div>
  )
}
